import { useMemo } from "react";
import { usePurchaseStates } from "../usePurchaseStates";
import { useNoActivePurchaseStates } from "../useNoActivePurchaseStates";

export const useIsOtpCustomer = () => {
  const purchaseStates = usePurchaseStates();
  const noActivePurchaseStates = useNoActivePurchaseStates();
  return useMemo(
    () => purchaseStates.length === 0 || noActivePurchaseStates,
    [purchaseStates, noActivePurchaseStates]
  );
};
